export class InvestigationChecklistStepEntity {
  public id!: string;
  public description!: string;
  public displayOrder!: number;
  public isCompleted!: boolean;
}
